<template>
  <div class="container">
    <b-navbar class="my-3">
      <template slot="brand">
        <b-navbar-item tag="router-link" :to="{ path: '/' }">
          <img :src="$store.getters.getBrandLogo" alt="Qonda" />
        </b-navbar-item>
      </template>
      <template slot="start">
        <b-navbar-item href="#" @click="goToDashboard">
          {{ $t("dashboard") }}
        </b-navbar-item>
        <b-navbar-item v-if="translator.exists" href="#" @click="goToTranslatorDashboard">
          {{ $t("translatorAcc") }}
        </b-navbar-item>
      </template>

      <template slot="end">
        <b-navbar-item tag="div">
          <b-select v-model="$i18n.locale" rounded boxed>
            <option v-for="(lang, i) in Object.keys($i18n.messages)" :key="`Lang${i}`" :value="lang">
              {{ lang }}
            </option>
          </b-select>
        </b-navbar-item>
        <b-navbar-item tag="div">
          <div v-if="$store.getters.getCurrentUser" class="level">
            <b-navbar-dropdown
              class="mr-4"
              :label="$store.getters.getOrganizationName || $t('companySwitcher')"
              aria-role="list"
            >
              <div v-for="org in organizations" :key="org.id">
                <b-navbar-item
                  tag="router-link"
                  class="expanded"
                  :to="{
                    name: 'Dashboard',
                    params: { organizationId: org.id },
                  }"
                >
                  <b :style="'color:' + org.branding.primaryColor">{{ org.legalName }}</b>
                </b-navbar-item>
              </div>
              <b-navbar-item
                v-if="this.$store.getters.getPermissions.includes('platform')"
                tag="router-link"
                :to="{ name: 'PlatformDashboard' }"
              >
                <b-icon class="ml-1 mr-2 is-hidden-mobile" icon="account-outline" />
                <div>
                  {{ $t("platformDashboard") }}
                </div>
              </b-navbar-item>
              <b-navbar-item tag="router-link" :to="{ name: 'Register', params: { target: 'organization' } }">
                <b-icon class="ml-1 mr-2 is-hidden-mobile" icon="plus" />
                {{ $t("createOrganization") }}
              </b-navbar-item>
            </b-navbar-dropdown>
            <a class="button is-light" @click="logout">
              {{ $t("logOut") }}
            </a>
            <b-button class="ml-2" tag="router-link" icon-left="account" :to="{ name: 'UserAccount' }" />
          </div>
          <div v-else class="buttons">
            <router-link :to="{ name: 'Register', params: {} }" class="button is-primary">
              <strong>{{ $t("signUp") }}</strong>
            </router-link>
            <router-link :to="{ name: 'Login' }" class="button is-light">
              {{ $t("logIn") }}
            </router-link>
          </div>
        </b-navbar-item>
      </template>
    </b-navbar>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { auth, db } from "@/firebase";

export default {
  name: "NavBar",
  props: {
    msg: {
      type: String,
    },
  },
  data() {
    return {
      organizations: [],
      translator: { exists: false },
    };
  },
  computed: {
    ...mapState({
      subscriptionDetails: (state) => state.subscriptionDetails,
    }),
  },
  async created() {
    auth.onAuthStateChanged(async (user) => {
      if (user) {
        try {
          this.translator = await db.collection("member_translators").doc(user.uid).get();
          let adminsSnap = await db.collectionGroup("admins").where("userId", "==", user.uid).get();
          this.organizations = [];
          for (let i in adminsSnap.docs) {
            let orgSnap = await adminsSnap.docs[i].ref.parent.parent.get();
            let obj = orgSnap.data();
            obj.id = orgSnap.id;
            this.organizations.push(obj);
          }
        } catch (err) {
          console.error("File: Navbar.vue, line: 185 ", err);
          throw "File: NavBar.vue, Could not connect to Firebase";
        }
      } else {
        this.organizations = [];
      }
    });
  },
  methods: {
    logout() {
      this.$store.dispatch("logOutUser");
      this.$router.push({ name: "Login" });
    },
    goToDashboard() {
      this.$store.commit("set_routeTosubsPage", false);
      if (
        typeof this.$store.getters.getOrganizationId == "undefined" ||
        this.$store.getters.getOrganizationId.length == 0
      ) {
        this.$router.push({ name: "Login" });
      } else {
        this.$router.push({
          name: "Dashboard",
          params: { organizationId: this.$store.getters.getOrganizationId },
        });
      }
    },
    goToTranslatorDashboard() {
      this.$router.push({
        name: "TranslatorDashboard",
        params: { translatorId: this.$store.getters.getCurrentUser.uid },
      });
    },
  },
};
</script>

<style scoped>
.navbar-item img {
  max-height: 3rem;
}
</style>
